import { jsx } from 'react/jsx-runtime';
import { InputField } from '@design-system/input-field';
import { CheckboxGroup } from '@phx-husky/checkbox-group';
import { DateField } from '@phx-husky/date-field';
import { Radio } from '@phx-husky/radio';
import { TextField } from '@phx-husky/text-field';
import classNames from 'classnames';

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".field-module_field__bjs75 {\n  margin: var(--phx-fieldMargin, 0.5rem 0);\n}\n\n.field-module_field__bjs75 .cds-error-icon {\n  width: var(0.75rem);\n  height: var(0.75rem);\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZpZWxkLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0Usd0NBQXdDO0FBQzFDOztBQUNBO0VBQ0UsbUJBQW1CO0VBQ25CLG9CQUFvQjtBQUN0QiIsImZpbGUiOiJmaWVsZC5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5maWVsZCB7XG4gIG1hcmdpbjogdmFyKC0tcGh4LWZpZWxkTWFyZ2luLCAwLjVyZW0gMCk7XG59XG4uZmllbGQgOmdsb2JhbCguY2RzLWVycm9yLWljb24pIHtcbiAgd2lkdGg6IHZhcigwLjc1cmVtKTtcbiAgaGVpZ2h0OiB2YXIoMC43NXJlbSk7XG59Il19 */";
var styles = {"field":"field-module_field__bjs75"};
styleInject(css_248z);

var FieldType;
(function (FieldType) {
    FieldType["date"] = "date";
    FieldType["textbox"] = "text";
    FieldType["password"] = "password";
    FieldType["radio"] = "radio";
    FieldType["checkbox"] = "checkbox";
    FieldType["textarea"] = "textarea";
    FieldType["phone"] = "phone";
})(FieldType || (FieldType = {}));

const skipFields = [
    'category',
    'isRequired',
    'isRequiredInEdit',
    'regex',
    'showInEdit',
    'showInPreview',
    'showInProfile',
    'showInSignIn',
    'showInSignUp',
    'customValidator',
    'requiredIf',
    'sameAs',
    'order',
];
const Field = (_a) => {
    var { type = FieldType.textbox, className } = _a, rest = __rest(_a, ["type", "className"]);
    const deleteUnnecessaryFields = (fields, skipAdditionalFields = []) => {
        const fieldsToSkip = [...skipFields, ...skipAdditionalFields];
        return Object.keys(fields).reduce((prev, curr) => {
            if (fieldsToSkip.includes(curr)) {
                return prev;
            }
            return Object.assign(Object.assign({}, prev), { [curr]: fields[curr] });
        }, {});
    };
    const renderField = (fieldType) => {
        switch (fieldType) {
            case FieldType.password:
            case FieldType.textbox: {
                return (jsx(InputField, Object.assign({}, deleteUnnecessaryFields(rest, [
                    'defaultValue',
                ]), { inputType: fieldType })));
            }
            case FieldType.textarea: {
                return (jsx(TextField, Object.assign({ error: rest.errorMessage }, deleteUnnecessaryFields(rest), { type: fieldType })));
            }
            case FieldType.radio: {
                return jsx(Radio, Object.assign({}, deleteUnnecessaryFields(rest)));
            }
            case FieldType.checkbox: {
                return (jsx(CheckboxGroup, Object.assign({}, deleteUnnecessaryFields(rest))));
            }
            case FieldType.date: {
                return (jsx(DateField, Object.assign({ error: rest.errorMessage }, deleteUnnecessaryFields(rest))));
            }
            default:
                return null;
        }
    };
    return (jsx("div", Object.assign({ className: classNames(styles.field, className, 'field-wrapper') }, { children: renderField(type) })));
};

export { Field, FieldType };
